/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalGetAutomatedReleaseRecommendedDurationOverrides';

export type InternalGetAutomatedReleaseRecommendedDurationPathParams = NonNullable<
  operations['internalGetAutomatedReleaseRecommendedDuration']['parameters']['path']
>;

export type InternalGetAutomatedReleaseRecommendedDurationQueryParams = NonNullable<
  operations['internalGetAutomatedReleaseRecommendedDuration']['parameters']['query']
>;

export interface Input extends InternalGetAutomatedReleaseRecommendedDurationPathParams {
  apiVersion?: string;
  query: InternalGetAutomatedReleaseRecommendedDurationQueryParams;
}

export async function internalGetAutomatedReleaseRecommendedDuration(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/internal/projects/{projectKey}/environments/{environmentKey}/automated-releases/recommended-duration',
    {
      params: { path, query },
      headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
      signal,
    },
  );
}
